import React, {Component} from 'react';
import {Radio, Row} from "antd";
import {app} from "../../app";
import IList from "./IntroduceList";

const RadioGroup = Radio.Group
const RadioButton = Radio.Button

class Introduce extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sel_tab: null
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.setData({ sel_tab: '1' })
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 选项选择变更
     * @param e
     */
    handleTabChange = (e) => {
        let { value } = e.target
        let { sel_tab } = this.state
        if (value === sel_tab) return
        this.setData({ sel_tab: value })
    }

    render() {
        let { sel_tab } = this.state,
            content,
            tab_disabled = !sel_tab
        switch (sel_tab) {
            case "1":
                content = (<IList history={this.props.history} />)
                break
        }
        return(
            <div className="st-course">
                <Row className="top-title">
                    <RadioGroup size="large" value={sel_tab} buttonStyle="solid" onChange={this.handleTabChange}>
                        <RadioButton className='no-select' value="1" disabled={tab_disabled}>培训课程介绍</RadioButton>
                    </RadioGroup>
                </Row>
                <Row className="content">
                    {content}
                </Row>
            </div>
        );
    }
}
export default Introduce;



// WEBPACK FOOTER //
// ./src/routes/skillTrain/Introduce.jsx